import React, {Component} from 'react';
import {SharedMapContextConsumer} from "../contexts/SharedMapContext";
import GoogleMapReact from 'google-map-react';
import Marker from './Marker';
import PricedMarker from './PricedMarker';
import ClusterMarker from './ClusterMarker';
import PointerMarker from './PointerMarker';
import "@babel/polyfill";

class Map extends Component {

    render() {
        return (
            <SharedMapContextConsumer>
                {({
                      mapOptionsCreator,
                      googleApiLoaded,
                      selectedItem,
                      points,
                      clusters,
                      visibility,
                      handleMapChange,
                      getItemById,
                      prices,
                      visibleTooltipItemId,
                      handleMarkerClick,
                      handleCloseTooltip,
                      mapOptions
                  }) => (
                    <GoogleMapReact
                        bootstrapURLKeys={{key: document.getElementById('map-root').getAttribute('data-api-key')}}
                        onGoogleApiLoaded={googleApiLoaded}
                        defaultCenter={this.props.center}
                        center={mapOptions.center}
                        zoom={mapOptions.zoom}
                        defaultZoom={this.props.zoom}
                        options={mapOptionsCreator}
                        onChange={handleMapChange}
                        yesIWantToUseGoogleMapApiInternals
                    >

                        {
                            // selected item goes beyond the standard procedure
                            selectedItem !== null &&
                            <PointerMarker
                                item={selectedItem}
                                key={selectedItem.id}
                                lat={selectedItem.lat}
                                lng={selectedItem.lng}
                                type={selectedItem.category}
                                showTooltip={visibleTooltipItemId === selectedItem.id}
                                onClick={() => {
                                    handleMarkerClick(selectedItem.id)
                                }}
                                onTooltipClose={handleCloseTooltip}
                            />
                        }


                        {Object.entries(clusters).map(([category, content]) => (
                            content.map(item => {
                                if (item.numPoints === 1 || mapOptions.zoom >= 13) {
                                    return item.points.map((itemPoint) => {
                                        const currentId = itemPoint.id;
                                        if (typeof prices === 'object' && currentId in prices) {
                                            return (
                                                <PricedMarker
                                                    item={getItemById(currentId)}
                                                    key={itemPoint.id}
                                                    lat={itemPoint.lat}
                                                    lng={itemPoint.lng}
                                                    type={category}
                                                    price={prices[currentId]}
                                                    showTooltip={visibleTooltipItemId === currentId}
                                                    onClick={() => {
                                                        handleMarkerClick(currentId)
                                                    }}
                                                    onTooltipClose={handleCloseTooltip}
                                                />
                                            )
                                        } else {
                                            return (
                                                <Marker item={getItemById(currentId)}
                                                        key={itemPoint.id}
                                                        lat={itemPoint.lat}
                                                        lng={itemPoint.lng}
                                                        type={category}
                                                        showTooltip={visibleTooltipItemId === currentId}
                                                        onClick={() => {
                                                            handleMarkerClick(currentId)
                                                        }}
                                                        onTooltipClose={handleCloseTooltip}
                                                />
                                            );
                                        }

                                    });
                                }

                                return (
                                    <ClusterMarker
                                        key={item.id}
                                        lat={item.lat}
                                        lng={item.lng}
                                        numPoints={item.numPoints}
                                        type={category}
                                    />
                                );
                            })

                        ))}

                    </GoogleMapReact>
                )}
            </SharedMapContextConsumer>
        );
    }
}

export default Map;
